import { render, staticRenderFns } from "./pl3.vue?vue&type=template&id=9e46c55e&scoped=true"
var script = {}
import style0 from "./pl3.vue?vue&type=style&index=0&id=9e46c55e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e46c55e",
  null
  
)

export default component.exports